import { useMemo } from 'react';
import { CartItem } from '../redux/slices/cartSlice';
import { OrderType } from './useCheckoutForm';

export const useOrderCalculations = (cartItems: CartItem[], orderType: OrderType) => {
  const calculations = useMemo(() => {
    const subtotal = cartItems.reduce((total, item) => {
      const itemTotal = item.totalPrice * item.quantity;
      return total + itemTotal;
    }, 0);
    
    const deliveryFee = 0; // Delivery fee calculated by API
    const tax = 0; // No tax applied
    const total = subtotal + deliveryFee; // No tax applied

    return {
      subtotal,
      deliveryFee,
      tax,
      total,
    };
  }, [cartItems, orderType]);

  return calculations;
};
